import { Logger } from '@sitecore-search/common';
import { OCContext } from '@sitecore-search/data';
import Actions from '../actions.js';
import Dispatcher from '../dispatcher.js';
import { BaseController } from './baseController.js';
export class OrderCloudController extends BaseController {
    constructor() {
        super();
        Object.defineProperty(this, "ocContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.setContext(new OCContext());
        Dispatcher.subscribe(this);
    }
    setContext(newOCContext) {
        this.ocContext = newOCContext;
        this.ocContext.addListener(this);
    }
    getContext() {
        return this.ocContext;
    }
    handleAction(action) {
        switch (action.type) {
            case Actions.OC_CONTEXT_CHANGED: {
                Logger.info('OC Context changed');
                break;
            }
            case Actions.INITIALIZE: {
                this.initialize();
                break;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange(observable, name, value) {
        if (this.initialized) {
            Dispatcher.dispatch({
                type: Actions.OC_CONTEXT_CHANGED,
                payload: { context: this.ocContext },
            });
        }
    }
}
export default new OrderCloudController();
